// export const originUrl  = "http://localhost/git/llaopbi/";
export const originUrl  = "https://llao.aeinformatica.net/";

export const backEndUrl = originUrl+"back-end/";
// export const backEndUrl = originUrl+"back-end/"
// export const backEndUrl = "http://10.1.1.5/git/powerbi/back-end/";